import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Image } from "antd";
import sal from "sal.js";
import "../NotreSolutionScreen/NotreSolutionScreen.css";
import "./PresentationANS.css";
import diplomeImage from "../../media/distinction_ministre_sante.webp";
import talentsImage from "../../media/pageQuiSommesNous/evenements/talents-esante-2024-1.webp";
import videoPoster from "../../media/pageNotreSolution/video-demo-poster.webp";

const ANS_URL =
  "https://esante.gouv.fr/lagence/les-talents-de-la-e-sante-2024";

function PresentationANS() {
  const [videoPlaying, setVideoPlaying] = useState(false);
  const videoRef = useRef(null);

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setVideoPlaying(true);
    }
  };

  useEffect(() => {
    sal();
  }, []);

  return (
    <div className="ns-page">
      <section className="ns-hero" id="video">
        <div className="ns-inner">
          <div data-sal="slide-up" data-sal-duration="500">
            <h1 className="ns-hero-title">Talents de la e-santé 2024</h1>
            <p className="ns-hero-intro">
              RAVAIL a été distingué par le ministère de la Santé lors des
              Talents de la e-santé 2024, dans la catégorie prévention.
            </p>
          </div>

          <div
            className="ns-video-wrap"
            data-sal="slide-up"
            data-sal-duration="700"
            data-sal-delay="100"
          >
            <video
              ref={videoRef}
              className="ns-video"
              controls
              preload="none"
              poster={videoPoster}
              onPlay={() => setVideoPlaying(true)}
            >
              <source src="/presentation-ANS.webm" type="video/webm" />
              <source src="/presentation-ANS.mp4" type="video/mp4" />
              Télécharger la vidéo au{" "}
              <a href="/presentation-ANS.webm">format WEBM</a> ou au{" "}
              <a href="/presentation-ANS.mp4">format MP4</a>.
            </video>
            {!videoPlaying && (
              <button
                className="ns-video-play"
                onClick={handlePlayClick}
                aria-label="Lancer la vidéo"
              >
                <span className="ns-video-play-icon">▶</span>
              </button>
            )}
          </div>
        </div>
      </section>

      <div className="wave-ns-to-content" aria-hidden="true">
        <svg
          viewBox="0 0 1280 120"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 120 H1280 V60 C1000 0 300 120 0 40 Z" fill="#fefefe" />
        </svg>
      </div>

      <section className="pans-diplome-section">
        <div className="ns-inner">
          <div
            className="pans-diplome-wrap"
            data-sal="slide-up"
            data-sal-duration="700"
            data-sal-delay="100"
          >
            <Image.PreviewGroup>
              <Image
                rootClassName="pans-diplome"
                src={diplomeImage}
                alt="Distinction du ministre de la Santé — Talents de la e-santé 2024"
              />
              <Image
                rootClassName="pans-talents"
                src={talentsImage}
                alt="Cérémonie des Talents de la e-santé 2024"
              />
            </Image.PreviewGroup>
          </div>
        </div>
      </section>

      <div className="pans-actions">
        <a
          className="ns-cta-btn ns-cta-btn--secondary"
          href={ANS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          Présentation sur le site de l'ANS
        </a>
        <Link to="/notre-solution" className="ns-cta-btn ns-cta-btn--primary">
          Découvrir RAVAIL
        </Link>
      </div>
    </div>
  );
}

export default PresentationANS;
